import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Empresas from "@/pages/Empresas";
import DnaMarca from "@/pages/DnaMarca";
import Campanhas from "@/pages/Campanhas";
import Calendario from "@/pages/Calendario";
import Aprovacao from "@/pages/Aprovacao";
import Midia from "@/pages/Midia";
import YouTubeStudio from "@/pages/YouTubeStudio";
import Conexoes from "@/pages/Conexoes";
import Analytics from "@/pages/Analytics";
import Ideias from "@/pages/Ideias";
import Ajuda from "@/pages/Ajuda";
import SuperAdmin from "@/pages/SuperAdmin";
import Privacidade from "@/pages/Privacidade";
import Termos from "@/pages/Termos";
import ExclusaoDados from "@/pages/ExclusaoDados";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-loading">
        <div className="h-10 w-10 rounded-full border-4 border-slate-200 border-t-[#3457d5] animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacidade" element={<Privacidade />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/exclusao-de-dados" element={<ExclusaoDados />} />
          <Route path="/app" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="empresas" element={<Empresas />} />
            <Route path="dna" element={<DnaMarca />} />
            <Route path="campanhas" element={<Campanhas />} />
            <Route path="calendario" element={<Calendario />} />
            <Route path="aprovacao" element={<Aprovacao />} />
            <Route path="midia" element={<Midia />} />
            <Route path="youtube" element={<YouTubeStudio />} />
            <Route path="conexoes" element={<Conexoes />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="ideias" element={<Ideias />} />
            <Route path="ajuda" element={<Ajuda />} />
            <Route path="admin" element={<SuperAdmin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
